module.exports = __webpack_public_path__ + "static/media/BannerCelfocus.6f7a974e.jpg";